import { render, staticRenderFns } from "./LfCourse.vue?vue&type=template&id=0110283a&scoped=true&"
import script from "./LfCourse.vue?vue&type=script&lang=js&"
export * from "./LfCourse.vue?vue&type=script&lang=js&"
import style0 from "./LfCourse.vue?vue&type=style&index=0&id=0110283a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0110283a",
  null
  
)

export default component.exports